export function toTitleCase(title) {
    return title.replace(/\w\S*/g, function(txt){
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
}

export function formatBlogDate(apiDate) {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    const formattedDate = new Date(apiDate).toLocaleDateString('en-US', options);
    return formattedDate;
}

export function formatShortPhoneNumber  (input) {
    const numericInput = input.replace(/[^0-9]/g, '');
    if (numericInput.length <= 3) {
      return numericInput;
    } else if (numericInput.length <= 6) {
      return `(${numericInput.slice(0, 3)}) ${numericInput.slice(3)}`;
    } else if (numericInput.length <= 10) {
      return `(${numericInput.slice(0, 3)}) ${numericInput.slice(3, 6)}-${numericInput.slice(6)}`;
    } else {
      return `(${numericInput.slice(0, 3)}) ${numericInput.slice(3, 6)}-${numericInput.slice(6, 10)}`;
    }
};

export function capitalizeLocal(str) {
    return str.replace(/\b\w/g, match => match.toUpperCase());
}


export function cleanPhoneNumber (phoneNumber)  {
  return phoneNumber.replace(/\D/g, '');
}

export const AffiliateSubmitted = (url, site_id, appt) => {
  if (typeof window !== 'undefined') {
    // Execute GTM script
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'S2S_APT_Submit',
        'pageUrl': url,
        'store-id': site_id,
        'AppointmentDate': appt,
        'Brand': "California Check Cashing Stores",
    }); 
  }
}
export const GetStartedSubmitted = (url, site_id,city, zip) => {
  if (typeof window !== 'undefined') {
    // Execute GTM script
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'GetStarted_Short_Form_Submit',
        'pageUrl': url,
        'store-id': site_id,
        'city': city,
        'zip': zip,
        'Brand': "California Check Cashing Stores",
    }); 
  }
}